import { BulkErrorBoundary } from '@components/Alerts/ErrorBoundaryFallback';
import { Header } from '@components/Header/Header';
import dynamic from 'next/dynamic';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

// lazy load to prioritise carousel
const FooterDynamic = dynamic(() =>
  import('../../components/Footer/Footer').then((mod) => mod.Footer)
);

const HomepageLayout: FC<Props> = ({ children }) => {
  return (
    <>
      <Header />
      <BulkErrorBoundary location="Home Page Layout">
        {children}
      </BulkErrorBoundary>
      <FooterDynamic />
    </>
  );
};

export { HomepageLayout };
